'use client';
import SiteFindBestPlanComponent from '@/components/plans/SiteFindBestPlanComponent';
import React from 'react';

interface PageContentProps {
  locale: string;
}

export default function PageContent({ locale }: PageContentProps) {
  return <SiteFindBestPlanComponent locale={locale} />;
}
